import React, { useState } from "react";
import { ReactComponent as VaultSVG } from "../assets/unlocked-vault.svg";
import { ReactComponent as Hero } from "../assets/heroes/what-if.svg";

function HowItWorks() {
  return (
    <section>
      <div
        className="max-w-6xl mx-auto px-4 sm:px-6 items-center"
        data-aos-id-gen-method-anchor
      >
        <div className="md:py-20 border-t border-gray-800 w-full">
          {/* Section header */}
          <div className="flex flex-col max-w-3xl mx-auto text-center items-center w-full">
            <div
              className="text-4xl md:text-6xl font-extrabold text-primary-1 mb-0 md:mb-20 mt-20 md:mt-0"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              How It Works
            </div>
            <div
              className="text-xxl h1 text-white md:mt-0 mt-10"
              data-aos="fade-right"
              data-aos-delay="800"
            >
              {"Give... Generate... Repeat..."}
            </div>
          </div>
          {/* Mobile */}
          <div className="md:hidden flex flex-col items-center">
            <div className="flex justify-center" data-aos="fade-up">
              <Hero
                className="w-full mt-10"
                data-aos="fade-up"
                data-aos-delay="600"
              />
            </div>
            <div className="flex flex-col items-center text-center justify-center pr-6 w-full">
              {/* <div className="flex w-full items-center justify-center mb-10">
                    <ValueCreationIcon className="w-36 mb-4 text-primary-1 fill-current" />
                  </div> */}
              <div className="text-4xl font-bold mb-2 text-white">1. Give</div>
              <p className="text-3xl text-white mb-10">
                Gift gems to community members. Each gift earns you a new vault.
              </p>
              <div className="text-4xl font-bold mb-2 text-white">
                2. Generate
              </div>
              <p className="text-3xl text-white mb-10">
                When your vaults fill with community gems, they cycle and
                generate Gencoin worth real money.
              </p>
              <div className="text-4xl font-bold mb-2 text-white">
                3. Repeat
              </div>
              <p className="text-3xl text-white mb-10">
                Use Gencoin for causes or cash. More giving = more vaults = more
                capacity to give.
              </p>
            </div>
          </div>

          {/* Desktop and Tablet */}
          <div className="hidden md:flex flex-col">
            <div
              className="flex mb-36 items-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="flex flex-col items-start justify-center pr-6 w-1/2">
                {/* <div className="flex w-full items-center justify-center mb-10">
                    <ValueCreationIcon className="w-36 mb-4 text-primary-1 fill-current" />
                  </div> */}
                <div className="text-4xl font-bold mb-2 text-white">
                  1. Give
                </div>
                <p className="text-3xl text-white mb-10">
                  Gift gems to community members. Each gift earns you a new
                  vault.
                </p>
                <div className="text-4xl font-bold mb-2 text-white">
                  2. Generate
                </div>
                <p className="text-3xl text-white mb-10">
                  When your vaults fill with community gems, they cycle and
                  generate Gencoin worth real money.
                </p>
                <div className="text-4xl font-bold mb-2 text-white">
                  3. Repeat
                </div>
                <p className="text-3xl text-white mb-10">
                  Use Gencoin for causes or cash. More giving = more vaults =
                  more capacity to give.
                </p>
              </div>

              <div
                className="flex justify-center w-1/2 p-20"
                data-aos="fade-up"
              >
                <Hero
                  className="w-full mt-10"
                  data-aos="fade-up"
                  data-aos-delay="600"
                />
              </div>
            </div>
          </div>

          <div
            className="flex w-full items-center justify-center md:mt-0 mb-10 md:mb-0"
            data-aos="fade-up"
            data-aos-delay="1000"
          >
            <img
              className="md:w-5/6 md:px-20 mt-10 md:mt-0"
              src={require(`../images/phone/double-peak.png`).default}
              alt="phone-profile"
            />
          </div>

          {/* How It Works */}
          {/* <div className="flex flex-col max-w-3xl mx-auto text-center items-center mt-10 md:mt-24 mb-20">
            <div
              className="text-4xl h4 mb-6 text-white text-center"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              Giving That Generates More Giving...
            </div>
            <div className="flex justify-center w-full" data-aos="fade-up">
              <VaultSVG
                className="w-5/12 mt-10"
                data-aos="fade-up"
                data-aos-delay="600"
              />
            </div>
          </div> */}
        </div>
      </div>
      {/* <Flow /> */}
    </section>
  );
}

export default HowItWorks;
